import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import * as React from 'react';
import { TOASTS_CONTEXT_ERROR_MESSAGES } from './constants.js';
import { toastsReducer } from './toastsReducer.js';
import { jsx } from 'react/jsx-runtime';

var ToastsDispatchContext = /*#__PURE__*/React.createContext(null);
var ToastsStateContext = /*#__PURE__*/React.createContext(null);
var ToastsContext = function ToastsContext(props) {
  var initialState = {
    toasts: []
  };
  var _React$useReducer = React.useReducer(toastsReducer, initialState),
    _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
    state = _React$useReducer2[0],
    dispatch = _React$useReducer2[1];
  return /*#__PURE__*/jsx(ToastsDispatchContext.Provider, {
    value: dispatch,
    children: /*#__PURE__*/jsx(ToastsStateContext.Provider, {
      value: {
        toasts: state.toasts
      },
      children: props.children
    })
  });
};
ToastsContext.displayName = "ToastsContext";
function useToastsDispatchContext() {
  var toastsDispatchContext = React.useContext(ToastsDispatchContext);
  if (!toastsDispatchContext) {
    throw new TypeError(TOASTS_CONTEXT_ERROR_MESSAGES.NO_TOASTS_DISPATCH_CONTEXT);
  }
  return toastsDispatchContext;
}
function useToastsStateContext() {
  var toastsStateContext = React.useContext(ToastsStateContext);
  if (!toastsStateContext) {
    throw new TypeError(TOASTS_CONTEXT_ERROR_MESSAGES.NO_TOASTS_STATE_CONTEXT);
  }
  return toastsStateContext;
}
var useToasts = function useToasts() {
  var dispatch = useToastsDispatchContext();
  return {
    addToast: function addToast(toast) {
      return dispatch({
        payload: toast,
        type: "ADD_TOAST"
      });
    },
    clearToasts: function clearToasts() {
      return dispatch({
        type: "CLEAR_TOASTS"
      });
    },
    removeToast: function removeToast(id) {
      return dispatch({
        payload: id,
        type: "REMOVE_TOAST"
      });
    },
    resetToasts: function resetToasts() {
      return dispatch({
        type: "RESET_TOASTS"
      });
    }
  };
};

export { ToastsContext, useToasts, useToastsStateContext };
